import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextLedeOpeningProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextLedeOpening = ({
  label,
  color = 'text-ds-natural',
  ellipsis,
}: TextLedeOpeningProps) => (
  <Typography
    color={color}
    label={label}
    tagName="h4"
    fontSize="text-ds-600"
    lineHeight="leading-ds-500"
    fontWeight="font-ds-normal"
    ellipsis={ellipsis}
  />
);
